import React from "react";
import "./header.css"
function Header(){
    return(
        <div>
            <header class="header">
  <div class="logo">MAKAUT CGPA CALCULATOR</div>
</header>
        </div>
    );
}

export default Header;